import { AutomationActionTypeEnum } from '../../../shared/models';
import { subEnum } from '../../../shared/models/enum/sub-enum.helper';

export const AutomationControlCodeActionEnum = subEnum(
  AutomationActionTypeEnum,
  ['exit', 'log', 'lookup', 'mark_control_as_completed'],
);
